import { type FunctionComponent, useState } from 'react';
import {
  EuiButton,
  EuiConfirmModal,
  EuiToolTip,
  useGeneratedHtmlId,
} from '@elastic/eui';
import useForceLogout from '@data/force-logout';
import type { Person } from '@domain/person';

interface ForceLogoutProps {
  person: Person;
}

const ForceLogout: FunctionComponent<ForceLogoutProps> = ({ person }) => {
  const { idnumber, firstname, surname } = person;
  const [forceLogout, { loading }] = useForceLogout();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);
  const modalTitleId = useGeneratedHtmlId();

  const handleClick = () => {
    forceLogout(idnumber).then(() => closeModal());
  };

  return (
    <>
      <EuiToolTip content="Force logout from all sessions">
        <EuiButton
          color="warning"
          iconType="lock"
          onClick={showModal}
          isLoading={loading}>
          Force logout
        </EuiButton>
      </EuiToolTip>

      {isModalVisible && (
        <EuiConfirmModal
          aria-labelledby={modalTitleId}
          title="Force logout?"
          titleProps={{ id: modalTitleId }}
          onCancel={closeModal}
          onConfirm={handleClick}
          cancelButtonText="Cancel"
          confirmButtonText="Logout"
          buttonColor="warning"
          defaultFocusedButton="confirm"
          isLoading={loading}>
          <p>
            Are you sure you want to force {firstname} {surname} to log out?
            This will log them out of all campaign apps.
          </p>
        </EuiConfirmModal>
      )}
    </>
  );
};

export default ForceLogout;
